module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(is_regenerate) { 
__p+='\n	<div class="league-regeneration-bar js-regeneration-bar">\n		<h4>Regenerate Last Year\'s Comps</h4>\n		<div class="description">\n			We have detected that you were the commissioner of one or more comps last season.\n			Why not use the comp regeneration tool to fast track your comp set-up for this year.\n		</div>\n		<div class="buttons-wrapper">\n			<a href="/comps/regeneration" class="base-btn primary-btn">Regenerate comps</a>\n			<a href="javascript:void(0)" class="not-show-regeneration js-not-show-regeneration">No thanks, don’t show me this message again.</a>\n		</div>\n	</div>\n';
 } 
__p+='\n<div class="competition-header">\n	<h2>Competitions</h2>\n	<h2>Rank</h2>\n</div>';
}
return __p;
};
